<div class="loading-overlay" *ngIf="visible() || hasError()" role="status" aria-live="polite">
  <!-- Error State -->
  @if (hasError()) {
    <div class="loading-overlay__error-content">
      <!-- Error Icon Container -->
      <div class="loading-overlay__error-icon-container">
        <div class="loading-overlay__error-icon">
          <app-icon
            name="error"
            [size]="64"
            color="#96080B"
            class="loading-overlay__error-icon-svg">
          </app-icon>
        </div>
      </div>

      <!-- Text Content -->
      <div class="loading-overlay__error-text-section">
        <h2 class="loading-overlay__error-title">{{ errorTitleKey() | translateLang }}</h2>
        <p class="loading-overlay__error-description">{{ errorDescriptionKey() | translateLang }}</p>
      </div>

      <!-- Suggestions Box -->
      <div class="loading-overlay__error-suggestions">
        <p class="loading-overlay__error-suggestions-heading">{{ errorSuggestionsHeadingKey() | translateLang }}</p>
        <div class="loading-overlay__error-suggestions-list">
          @for (suggestionKey of errorSuggestionKeys(); track suggestionKey) {
            <div class="loading-overlay__error-suggestion-item">
              <div class="loading-overlay__error-bullet">
                <span class="loading-overlay__error-bullet-text">•</span>
              </div>
              <p class="loading-overlay__error-suggestion-text">{{ suggestionKey | translateLang }}</p>
            </div>
          }
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="loading-overlay__error-actions">
        <button
          type="button"
          class="loading-overlay__error-button loading-overlay__error-button--primary"
          (click)="onRefresh()">
          {{ errorRefreshButtonKey() | translateLang }}
        </button>
        <button
          type="button"
          class="loading-overlay__error-button loading-overlay__error-button--secondary"
          (click)="onContactSupport()">
          {{ errorContactButtonKey() | translateLang }}
        </button>
      </div>

      <!-- Reassurance Message -->
      <p class="loading-overlay__error-reassurance">{{ errorReassuranceKey() | translateLang }}</p>
    </div>
  } @else {
    <!-- Loading State -->
    <div class="loading-overlay__content">
      <img
        src="/assets/images/icons/logo-spinner.gif"
        alt="Loading"
        class="loading-overlay__spinner"
      />
      <p class="loading-overlay__message">
        {{ messageKey() | translateLang }}
      </p>
      <div class="loading-overlay__progress" *ngIf="showProgress()">
        <div class="loading-overlay__progress-track">
          <div
            class="loading-overlay__progress-fill"
            [class.loading-overlay__progress-fill--indeterminate]="indeterminate()"
            [style.width.%]="indeterminate() ? null : percentage()"
          ></div>
        </div>
      </div>
    </div>
  }
</div>
